import { React, useState, useEffect, useRef } from "react";
import { updateRef, resetOption } from "../../../../Services/customerServices";
import { getStages } from "../../../../Services/optionService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import RadioElement from '../../../../Components/UiComponents/RadioElement';
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import DataTable from "../../../../Components/UiComponents/DataTable";
import Loader from "../../../../Components/UiComponents/Loader";
import _ from 'lodash';

export default function EditField(props) {
	const [groups, setGroups] = useState([
		{ _id: "option1", label: "", text: "", score: 0, status: "active" },
	]);
	const [formData, setFormData] = useState({
		option_names: "",
		factor: null,
		win_stage: null,
		option_type: null,
		weightage: "",
		option_status: "",
		groups: groups,
	});
	const [errors, setErrors] = useState({});
	const [visible, setVisible] = useState(false);
	const [stages, setStages] = useState([]);
	const [groupStatus] = useState([
		{ option: "Please Select", value: "" },
		{ option: "Active", value: "active" },
		{ option: "Inactive", value: "inactive" },
	]);
	const [intialFormData, setInitialFormData] = useState({});
	const [intialGroupData, setInitialGroupData] = useState({});
	const [columns, setColumns ] = useState([]);
	const [selectedOption, setSelectedOption] = useState([]);

	const factors = [
		{ name: "None", code: "None" },
		{ name: "Internal", code: "Internal" },
		{ name: "External", code: "External" },
	];
	const projectStages = [
		{ name: "None", code: "None" },
		{ name: "BD/Long Shot", code: "BD/Long Shot" },
		{ name: "PQQ", code: "PQQ" },
		{ name: "ITT", code: "ITT" },
	];
	const toastRef = useRef();
	const [groupErrors, setGroupErrors] = useState({});
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		getStage();
		const selectedRef = props?.customerDataAll?.reference_data?.filter(
			(item) => item._id === props?.editField._id
		)[0];
		const data = {
			// ...formData,
			option_names: selectedRef?.option_names,
			_id:props?.editField._id,
			factor: factors.filter((item) => item.name === props.editField.factor)[0],
			win_stage: projectStages.filter(
				(item) => item.name === props.editField.win_stage
			)[0],
			option_type: stages.filter(
				(item) => item.label === props.editField.option_type
			)[0],
			weightage: props?.editField?.weightage,
			option_status: props?.editField?.option_status === "true" ? "Yes" : "No",
			display_name: props?.editField?.display_name,
			groups: selectedRef?.option_choice ? selectedRef?.option_choice : groups,
		};
		setFormData(data);
		setInitialFormData(data);
		setInitialGroupData(_.cloneDeep(data.groups));
	}, [
		props.customerId,
		props?.editField,
		props?.visible,
		props?.customerDataAll,
	]);

	// Function to get stages fields data
	const getStage = async function () {
		try {
			var getStage = await getStages();
			getStage = getStage.data[0].option_choice;
			getStage.push({ label: "Common", text: "Common", status: "active" });
			setStages(getStage);
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: "Failed to fetch stages data"
			});
		}
	};

	// Add group options
	const handleAddGroup = () => {
		const newGroupId = `option${formData.groups.length + 1}`;
		const newGroup = {
			id: newGroupId, // or generate a unique id in a different way
			label: "",
			score: null,
			text: "",
			status: "active",
		};
		setFormData({
			...formData,
			groups: [...formData.groups, newGroup],
		});
	};
	// Remove group options
	const handleRemoveGroup = (groupId) => {
		const updatedGroups = formData.groups.filter((group) => {
			if (group._id) {
				return group._id !== groupId;
			} else {
				return group.id !== groupId;
			}
		});
		setFormData({
			...formData,
			groups: updatedGroups,
		});
	};

	// Update form when group values change
	const handleGroupChange = (groupId, field, value) => {
		const updatedGroups = formData.groups.map((group) => {
			if (group._id) {
				return group._id === groupId ? { ...group, [field]: value } : group;
			} else if (group.id === groupId) {
				return { ...group, [field]: value };
			} else {
				return group;
			}
		});
		setFormData({
			...formData,
			groups: updatedGroups,
		});
	};
	// Update customer ref data
	const updateField = async (formData) => {
		let finaldata = {
			_id: formData?._id,
			option_names: formData?.option_names,
			factor: formData.factor?.name,
			win_stage: formData?.win_stage?.name,
			option_type: formData?.option_type?.label,
			weightage: formData?.weightage,
			display_name: formData?.display_name,
			option_choice: formData?.groups,
			option_status: formData?.option_status === "Yes" ? "true" : "false",
		};
		const updatedRefData = props.customerDataAll.reference_data.map((rData) =>
			rData._id === finaldata._id
				? { ...rData, ...finaldata }
				: rData
		);

		const updatedCustomerData = {
			...props.customerDataAll,
			reference_data: updatedRefData,
		};
		try {
			if (props.customerId === null) {
				toastRef.current.showToast({
					type: 'error',
					message: 'Missing customer ID'
				});
				return;
			}
			setLoading(true)
			const customerData = await updateRef(
				props.customerId,
				updatedCustomerData
			);
			setVisible(false);
			props.onHide();
			setFormData({
				option_names: "",
				factor: null,
				win_stage: null,
				option_type: null,
				weightage: "",
				option_status: "",
				groups: groups,
			});

			props.getCustomerField();
			toastRef.current.showToast({
				type: "success",
				message: `Field updated Successfully`,
			});
		} catch (error) {
			toastRef.current.showToast({
				type: "error",
				message: `Error: failed to update field`,
			});
		} finally {
			setLoading(false)
		}
	};
	// close modal
	const closePopup = () => {
		setVisible(false);
		setFormData({
			option_names: "",
			factor: null,
			win_stage: null,
			option_type: null,
			weightage: "",
			option_status: "",
			groups: groups,
		});
		props.onHide();
		setErrors({});
		setGroupErrors({});
	};
	// Form validation
	const handleSubmit = (e) => {
		setLoading(true)
		// Check for errors in main form fields
		const newErrors = {};
		if (!formData.option_names) {
			newErrors.option_names = "required";
		}
		if (!formData.factor) {
			newErrors.factor = "required";
		}
		if (!formData.win_stage) {
			newErrors.win_stage = "required";
		}
		if (!formData.option_type) {
			newErrors.option_type = "required";
		}
		if (formData.weightage === undefined || formData.weightage === null) {
			newErrors.weightage = "required";
		}
		if (!formData.display_name) {
			newErrors.display_name = "required";
		}

		// Check for errors in group fields
		const newGroupErrors = {};
		formData.groups.forEach((group) => {
			const groupId = group._id || group.id;
			if (!group.label) {
				newGroupErrors[groupId] = {
					...newGroupErrors[groupId],
					option_label: "Label is required",
				};
			}
			if (
				!group.status ||
				!(group.status === "active" || group.status === "inactive")
			) {
				newGroupErrors[groupId] = {
					...newGroupErrors[groupId],
					option_status: "Status is required",
				};
			}
		});
		// Set errors and return if any errors exist
		if (
			Object.keys(newErrors).length > 0 ||
			Object.keys(newGroupErrors).length > 0
		) {
			setLoading(false)
			setErrors(newErrors);
			setGroupErrors(newGroupErrors);
			return;
		} else {

			// Handle form submission logic here
			formData.option_names &&
				formData.factor.name &&
				formData.win_stage.name &&
				formData.display_name &&
				Object.keys(groupErrors).length === 0 &&
				updateField(formData);
			setErrors({});
			setGroupErrors({});
		}
	};

	const handleInputChange = (field, value) => {
		setFormData({
			...formData,
			[field]: value,
		});
	};

	// Popup data table


	const handleDeleteOption = () => {
		const updatedOptions = formData.groups.filter(
			(row) => !selectedOption.includes(row)
		);
		setGroups(updatedOptions);
		setFormData((prevState) => ({ ...prevState, groups: updatedOptions }));
		setSelectedOption([]);
	};

	function generateRandomID() {
		const hexChars = '0123456789abcdef';
		let result = '';
		for (let i = 0; i < 24; i++) {
			result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
		}
		return result;
	}

	const handleAddOption = () => {
		const newRow = {
			_id: generateRandomID(),
			label: "",
			text: "",
			status: "",
		};
		setGroups([...groups, newRow]);
		setFormData((prevState) => ({
			...prevState,
			groups: [...prevState.groups, newRow],
		}));
	};

	const onCheckboxChange = (e, row) => {
		const updatedOptions = e.checked
			? [...selectedOption, row.id || row._id]
			: selectedOption.filter((optionId) => optionId !== (row.id || row._id));
		setSelectedOption(updatedOptions);
	};

	const onTextChange = (index, field) => (e) => {
		const newRows = [...formData.groups];
		if (field === "score") {
			newRows[index][field] = e.value;
		} else {
			newRows[index][field] = e.target.value;
		}
		// setOption(newRows);
		setFormData({ ...formData, groups: newRows });
	};

	const returnToDefault = async () => {
		try {
			if (props.customerId === null) {
				toastRef.current.showToast({
					type: 'error',
					message: 'Missing customer ID'
				});
				return;
			}
			const defaultData = await resetOption(props.customerId, formData.option_names);
			if (defaultData) {
				const data = {
					option_names: defaultData.data.optionData[0].option_names,
					factor: factors.filter((item) => item.name === defaultData.data.optionData[0].factor)[0],
					win_stage: projectStages.filter(
						(item) => item.name === defaultData.data.optionData[0].win_stage
					)[0],
					option_type: stages.filter(
						(item) => item.label === defaultData.data.optionData[0].option_type
					)[0],
					weightage: defaultData.data.optionData[0].weightage,
					option_status: defaultData.data.optionData[0].option_status === "true" ? "Yes" : "No",
					display_name: defaultData.data.optionData[0].display_name ? defaultData.data.optionData[0].display_name : defaultData.data.optionData[0].option_names,
					groups: defaultData.data.optionData[0]?.option_choice ? defaultData.data.optionData[0]?.option_choice : groups,
				};
				setFormData(data)
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		}
	}

	const renderFooter = (a) => {
		return (
			<div className="cancel-footer">
				<div className='align-center justify-end pb-0'>
					<ButtonElement label="Return To Default" className="cancel-new-button" onClick={() => returnToDefault()} />
					<ButtonElement type="submit" label="Update" className="save-button" onClick={() => handleSubmit()} />
				</div>
			</div>
		);
	}

	const labelEditor = (row, index) => {
		return (
			<InputTextElementElement
				className="dropdown-field-handle"
				value={row.label}
				placeholder="Value"
				onChange={onTextChange(index?.rowIndex, "label")}
			/>
		);
	};

	const statusEditor = (row, index) => {
		return (
			<DropdownElement
				value={row.status}
				onChange={onTextChange(index?.rowIndex, "status")}
				options={(groupStatus != undefined && groupStatus.length > 0) ? groupStatus : []}
				optionLabel="option"
				placeholder="-- Please select --"
			/>
		);
	};

	const scoreEditor = (row, index) => {
		return (
			<InputNumber
				className="dropdown-field-handle"
				value={row.score}
				placeholder="Score"
				onChange={onTextChange(index?.rowIndex, "score")}
				mode="decimal"
				incrementButtonClassName="custom-increment-button"
				decrementButtonClassName="custom-decrement-button"
				showButtons
			/>
		);
	};

	const textEditor = (row, index) => {
		return (
			<InputTextElementElement
				className="dropdown-field-handle"
				value={row.text}
				placeholder="Recommendation"
				onChange={onTextChange(index?.rowIndex, "text")}
				showButtons
			/>
		);
	};

	const filterArray = [
		"opportunityType",
		"WorkType",
		"logFrameGoal",
		"logFrameGoalQualitative",
		"logFrameTarget",
		"ProcurementRoute",
		"SectorV1",
		"ClientMeetings",
		"ConnectionsToProfessionalTeam",
		"ProjectType",
		"FrameworkLength",
		"SourceOfOpportunity",
		"FormOfContractV2",
		"FormOfContractV1",
		"TenderPeriod",
		"ProjectValue",
		"ProjectMargin",
		"ProjectDuration",
		"DeliveryTeamRoles",
		"Risks",
		"NoOfCompetitorsV2",
		"BondRequirement",
		"BimRequirement",
		"onerousTermsLADs",
		"PaymentTermsDays",
		"Winnability",
		"SelectionweightingFactors",
		"Funding",
		"Region",
		"BusinessUnit",
		"ProfitMorgin",
		"ClientHistory",
		"DepthOfClientEngagement",
		"ClientClassificationV1",
		"ClientClassificationV3",
		"clientTypeV1",
		"Geography",
		"AdvisorHistory",
		"DepthOfAdvisorEngagement",
		"ResourcingTheBid",
		"ResourcingTheProject",
		"WorkClassificationV2",
		"MarginExpected",
		"AdvisorType",
		"OrganisationTypeV1",
		"MultiOrgType",
		"AdvisorClassification",
		"FitWithBusinessPlan",
		"DeliveryTeamAvailability",
		"PlanningStatus",
		"OtherRisks",
		"RiskManagement",
		"BidTeamAvailability",
		"WinPlanSection",
		"Target",
		"BDLongShotRole",
		"ReviewHead",
		"RecommendedActions",
		"MidRecommendedActions",
		"Role",
		"LocalAuthorities",
		"WinWorkStage",
		"Services",
		"SubMainContractorBidStatus",
		"RiskType",
		"RiskCategory",
		"Profile",
		"SubmissionDocStatus",
		"SubmissionDocStatusFilter",
		"Breeam",
		"UnitofMeasurement",
		"Attribution",
		"Score"
	];
	  



	useEffect(() =>{
		setColumns([
			{ field: "label", header: "Label", body: labelEditor, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '40%' } },
			{ field: "score", header: "Score", body: scoreEditor, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '10%' } },
			{ field: "status", header: "Status", body: statusEditor, headerClassName: "header-datatable", className: 'row-datatable' , style: { width: '10%' } },
			...(
				filterArray.includes(formData.option_names) 
				? [{ field: "text", header: "Recommendation", body: textEditor, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '20%' } }]
				: []
			)
		]);
	}, [formData]);
	

	const rowClick = async (data) => {
		setSelectedOption(data)
	};

	const reorderClick = (data) => {
		setFormData((prevState) => ({ ...prevState, groups: data }));
	}

	//  Popup data table Ends..

	return (
		<div className="edit-field">
			<ToastElement ref={toastRef} />
			<Dialog
				header={`Edit ${props.editField.display_name != null &&
					props.editField.display_name != ""
					? props.editField.display_name
					: props.editField.option_names
					}`}
				visible={visible ? visible : props.visible}
				position={props.position}
				className="width-42"
				onHide={() => {
					closePopup();
				}}
				draggable={false}
				resizable={false}
				footer={renderFooter()}
			>
				<div className="new-field">
					<form onSubmit={handleSubmit}>
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{
										props.customerControlFields?.tables[0]?.headers[3]
											?.display_name
									}
								</label>
							</div>
							<div className="col pr-0">
								<InputTextElementElement
									id="refField"
									value={formData.option_names}
									onChange={(e) => handleInputChange("option_names", e.target.value)}
									required
									className="w-full"
									disabled
								/>
								{errors.option_names && (
									<small className="text-red-500 ml-1 mt-1">
										{errors.option_names}
									</small>
								)}
							</div>

						</div>
						<div className="form-group row align-items-center mt-0 mb-0" >
							<div className="col-md-4 text-left pl-0">
								<label className="form-label text-left">
									{
										props.customerControlFields?.tables[0]?.headers[4]
											?.display_name
									}
								</label>
							</div>
							<div className="col pr-0">
								<DropdownElement
									value={formData.factor}
									onChange={(e) => handleInputChange("factor", e.value)}
									id="factor"
									options={(factors != undefined && factors.length > 0) ? factors : []}
									optionLabel="name"
									placeholder="-- Please select --"
									className="w-full"
								/>
								{errors.factor && (
									<small className="text-red-500 ml-1 mt-1">
										{errors.factor}
									</small>
								)}
							</div>
						</div>

						<div className="form-group row align-items-center mt-0 mb-0" >
							<div className="col-md-4 text-left pl-0">
								<label className="form-label text-left">
									{
										props.customerControlFields?.tables[0]?.headers[5]
											?.display_name
									}
								</label>
							</div>
							<div className="col pr-0">
								<DropdownElement
									value={formData.win_stage}
									onChange={(e) => handleInputChange("win_stage", e.value)}
									options={(projectStages != undefined && projectStages.length > 0) ? projectStages : []}
									optionLabel="name"
									placeholder="-- Please select --"
									className="w-full"
								/>
								{errors.win_stage && (
									<small className="text-red-500 ml-1 mt-1">
										{errors.win_stage}
									</small>
								)}
							</div>
						</div>

						<div className="form-group row align-items-center mt-0 mb-0">
							<div className="col-md-4 text-left pl-0">
								<label className="form-label text-left">
									{
										props.customerControlFields?.tables[0]?.headers[6]
											?.display_name
									}
								</label>
							</div>
							<div className="col pr-0">
								<DropdownElement
									value={formData.option_type}
									onChange={(e) => handleInputChange("option_type", e.value)}
									options={(stages != undefined && stages.length > 0) ? stages : []}
									optionLabel="text"
									placeholder="-- Please select --"
									className="w-full"
								/>
								{errors.option_type && (
									<small className="text-red-500 ml-1 mt-1">
										{errors.option_type}
									</small>
								)}
							</div>
						</div>

						<div className="form-group row align-items-center mt-0 mb-0">
							<div className="col-md-4 text-left pl-0">
								<label className="form-label text-left">
									{
										props.customerControlFields?.tables[0]?.headers[7]
											?.display_name
									}
								</label>
							</div>
							<div className="col pr-0">
								<InputNumber
									id="stakeholder-name"
									value={formData.weightage}
									onChange={(e) => handleInputChange("weightage", e.value)}
									placeholder=""
									aria-describedby="username-help"
									className="w-full"
									mode="decimal"
									incrementButtonClassName="custom-increment-button"
									decrementButtonClassName="custom-decrement-button"
									showButtons
									required
								/>
								{errors.weightage && (
									<small className="text-red-500 ml-1 mt-1">
										{errors.weightage}
									</small>
								)}
							</div>
						</div>

						<div className="form-group row align-items-center mb-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{props.customerControlFields?.tables[0]?.headers[8]?.display_name}
								</label>
							</div>
							<div className="col pr-0">
								<InputTextElementElement
									id="refField"
									value={formData.display_name}
									onChange={(e) => handleInputChange("display_name", e.target.value)}
									required
									className="w-full"
								/>
								{errors.display_name && (
									<small className="text-red-500 ml-1 mt-1">
										{errors.display_name}
									</small>
								)}
							</div>
						</div>
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{props.customerControlFields?.tables[0]?.headers[9]?.display_name}
								</label>
							</div>
							<div className="col pr-0">
								<RadioElement
									options={[
										{ key: "Yes", name: "Yes" },
										{ key: "No", name: "No" },
									]}
									value={formData.option_status}
									onChangeRadio={(value) => {
										handleInputChange("option_status", value);
									}}
									className="radio-group-class" // Add any additional classes if necessary
									disabled={false} // Adjust the disabled prop as needed
								/>
							</div>

						</div>

						<div className="form-group row align-items-center mb-0">
							<div className="col-md-4 pl-0 pt-17">
								<p className="label-text">
									{
										props.customerControlFields?.tables[0]?.headers[10]
											?.display_name
									}
								</p>
							</div>
							<div className="col pr-0 d-flex justify-end">
								<ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteOption} />
								<ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={handleAddOption} />
							</div>
						</div>

						<div>
							<DataTable
								value={formData.groups}
								columns={columns}
								dataKey="_id"
								isCheckbox={true}
								rowClick={rowClick}
								reorderClick={reorderClick}
							/>
						</div>
					</form>
				</div>
			</Dialog>
		</div>
	);
}
